import BuildingAddress3 from "../BuildingAddress3";
import RenameBuilding3 from "../RenameBuilding3";
import styles from "./BuildingInfo.module.scss";

export interface IBuildingInfo3Props {}

const BuildingInfo3 = (props: IBuildingInfo3Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.copy}>
        <RenameBuilding3 />
      </div>
      <BuildingAddress3 />
    </div>
  );
};

export default BuildingInfo3;
